import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		// /?safe&mock-data&utm_source=FB&country=US&area=main&exp=web_sunday_offer_landing~1
		main: {
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_sunday_offer_landing'),
			},
		},
		// /tai-chi-walking?safe&mock-data&utm_source=FB&country=US&area=main-tai-chi-walking&exp=web_sunday_offer_landing~1
		'main-tai-chi-walking': {
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_sunday_offer_landing'),
			},
		},
	},
]

export default config
